<div nz-flex [nzGap]="'small'" [nzVertical]="true">
  <div>
    <div class="header-wrapper">
      <h1>Lista procedur</h1>
      <button nz-button nzType="primary" [nzSize]="'default'" (click)="createProcedureClick()">
        <nz-icon nzType="plus-circle" nzTheme="outline" />
        Dodaj procedurę
      </button>
    </div>
    <div nz-flex [nzGap]="'small'" [nzVertical]="false">
      <div>
        <button nz-button nz-dropdown [nzDropdownMenu]="typeMenu">
          {{ modalities().find((m) => m.code === filters().type)?.name || 'Wszystkie typy' }}
          <nz-icon nzType="down" />
        </button>
        <nz-dropdown-menu #typeMenu="nzDropdownMenu">
          <ul nz-menu>
            @for (item of modalities(); track $index) {
              <li nz-menu-item (click)="filters.update((f) => ({ ...f, type: item.code }))">
                {{ item.name }}
              </li>
            }
            <li nz-menu-item (click)="filters.update((f) => ({ ...f, type: null }))">
              Wszystkie typy
            </li>
          </ul>
        </nz-dropdown-menu>
      </div>
      <input
        nz-input
        placeholder="Szukaj.."
        [ngModel]="filters().query"
        (ngModelChange)="queryChange($event)"
      />
    </div>
  </div>

  <nz-table
    #proceduresTable
    [nzData]="searchResult()?.results ?? []"
    [nzBordered]="true"
    [nzLoading]="loading()"
    [nzPageSize]="pageSize"
    [nzPageIndex]="pageIndex"
    [nzTotal]="total"
    [nzFrontPagination]="false"
    (nzQueryParams)="onQueryParamsChange($event)"
    nzTableLayout="fixed"
  >
    <thead>
      <tr>
        <th nzColumnKey="id" [nzSortFn]="true" [nzSortOrder]="'descend'">Id</th>
        <th nzColumnKey="type" [nzSortFn]="true">Typ</th>
        <th nzColumnKey="name" [nzSortFn]="true">Nazwa</th>
        <th nzColumnKey="icd9Code" [nzSortFn]="true">ICD-9</th>
        <th nzColumnKey="bodyAreaName" [nzSortFn]="true">Obszar ciała</th>
        <th nzColumnKey="defaultEtcInMinutes" [nzSortFn]="true">Czas wykonania</th>
        <th nzColumnKey="withContrast" [nzSortFn]="true">Z kontrastem</th>
        <th nzColumnKey="isHidden" [nzSortFn]="true">Widoczność</th>
        <th class="mhs-table-action-header">Akcja</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let procedure of proceduresTable.data">
        <td>{{ procedure.id }}</td>
        <td>
          <nz-tag nzColor="green">{{ procedure.type }}</nz-tag>
        </td>
        <td>{{ procedure.name }}</td>
        <td>{{ procedure.icd9Code || '-' }}</td>
        <td>{{ procedure.bodyAreaName || '-' }}</td>
        <td>
          {{ procedure.defaultEtcInMinutes ?? '-' }}
          @if (procedure.defaultEtcInMinutes) {
            <span>min</span>
          }
        </td>
        <td>
          <div
            class="mhs-boolean-icon"
            [attr.aria-label]="procedure.withContrast ? 'Tak' : 'Nie'"
            [title]="procedure.withContrast ? 'Tak' : 'Nie'"
          >
            <nz-icon [nzType]="procedure.withContrast ? 'check' : 'close'" />
          </div>
        </td>
        <td>
          <div
            class="mhs-boolean-icon"
            [attr.aria-label]="procedure.isHidden ? 'Ukryty' : 'Widoczny'"
            [title]="procedure.isHidden ? 'Ukryty' : 'Widoczny'"
          >
            <nz-icon [nzType]="procedure.isHidden ? 'close' : 'check'" />
          </div>
        </td>
        <td class="mhs-table-actions-cell">
          <div class="mhs-table-actions" nz-flex [nzGap]="'small'" [nzVertical]="false">
            <button
              nz-button
              nzType="primary"
              nzShape="circle"
              (click)="detailsClick(procedure.id!)"
            >
              <nz-icon nzType="search" />
            </button>
            <a
              nz-dropdown
              [nzDropdownMenu]="userActionsMenu"
              nz-button
              nzType="default"
              nzShape="circle"
            >
              <nz-icon nzType="menu-fold" nzTheme="outline" />
            </a>
            <nz-dropdown-menu #userActionsMenu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item (click)="editProcedureClick(procedure.id!)">Edytuj</li>
                <li
                  *ngIf="procedure.isHidden"
                  nz-menu-item
                  (click)="unhideProcedureClick(procedure.id!)"
                >
                  Odkryj
                </li>
                <li
                  *ngIf="!procedure.isHidden"
                  nz-menu-item
                  (click)="hideProcedureClick(procedure.id!)"
                >
                  Ukryj
                </li>
              </ul>
            </nz-dropdown-menu>
          </div>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>
